export const copyrights =
    ' ©2024 Designed and developed by Emmanouil Smyrnakis';
